import React, { lazy, Suspense, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
const AddLoyalitySettingModal = lazy(() =>
  import("src/features/Modal").then((modal) => ({
    default: modal.AddLoyalitySetting,
  }))
);

export default function AddPriceButton() {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <Button
        style={{ marginBottom: 15 }}
        icon={<PlusOutlined />}
        type="primary"
        onClick={() => setOpen(true)}
      >
        Добавить настройки к карте
      </Button>
      {isOpen ? (
        <Suspense fallback={<div></div>}>
          <AddLoyalitySettingModal isOpen={isOpen} setOpen={setOpen} />
        </Suspense>
      ) : null}
    </>
  );
}
